<template>
  <div>
    <div>
      <van-tabs
        @change="change"
        v-model="active"
        color="#009fff"
        line-width="70px"
      >
        <van-tab title="提交工单" title-style="border-radius: 20px;">
          <Orders :fom="fom"></Orders>
        </van-tab>
        <van-tab title="待处理" title-style="border-radius: 20px;">
          <div
            style="
              margin: 20px;
              box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
              text-align: left;
            "
            v-for="item in all"
            :key="item.id"
          >
            <p class="padd">
              问题卡号：{{ item.card }}
              <van-button
                @click="password(item.id)"
                style="float: right"
                type="primary"
                size="mini"
              >
                查看工单
              </van-button>
            </p>
            <div class="padds">问题类型：{{ item.workOrderType }}</div>
            <div class="padds">
              工单状态：{{ item.state == true ? "已处理" : "待处理" }}
            </div>
            <div class="padds">提交时间：{{ item.addTime }}</div>
          </div>
          <van-empty
            v-show="all.length == 0"
            description="暂无数据"
          ></van-empty>
        </van-tab>
        <van-tab title="已处理" title-style="border-radius: 20px;">
          <div
            style="
              margin: 20px;
              box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
              text-align: left;
            "
            v-for="item in all"
            :key="item.id"
          >
            <p class="padd">
              问题卡号：{{ item.card }}
              <van-button
                @click="password(item.id)"
                style="float: right"
                type="primary"
                size="mini"
              >
                查看工单
              </van-button>
            </p>
            <div class="padds">问题类型：{{ item.workOrderType }}</div>
            <div class="padds">
              工单状态：{{ item.state == true ? "已处理" : "待处理" }}
            </div>
            <div class="padds">提交时间：{{ item.addTime }}</div>
          </div>
          <van-empty
            v-show="all.length == 0"
            description="暂无数据"
          ></van-empty>
        </van-tab>
        <van-tab title="全部工单" title-style="border-radius: 20px;">
          <div
            style="
              margin: 20px;
              box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
              text-align: left;
            "
            v-for="item in all"
            :key="item.id"
          >
            <p class="padd">
              问题卡号：{{ item.card }}
              <van-button
                @click="password(item.id)"
                style="float: right"
                type="primary"
                size="mini"
              >
                查看工单
              </van-button>
            </p>
            <div class="padds">问题类型：{{ item.workOrderType }}</div>
            <div class="padds">
              工单状态：{{ item.state == true ? "已处理" : "待处理" }}
            </div>
            <div class="padds">提交时间：{{ item.addTime }}</div>
          </div>
          <van-empty
            v-show="all.length == 0"
            description="暂无数据"
          ></van-empty>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
  import Orders from "../components/Order";
  import { selectAll, selectPage } from "@/api/cardOperation";
  export default {
    data() {
      return {
        active: "",
        s: false,
        state: null,
        all: [],
        columns: [],
        fom: {
          card: localStorage.getItem("meCardNum"),
          workOrderType: "",
          data: "",
          contactInformationType: 1,
          contactInformation: "",
          image: [],
        },
      };
    },
    components: {
      Orders,
    },
    created() {},
    mounted() {
      this.selectAll();
    },
    methods: {
      password(val) {
        this.$router.push(`/detailorders/${val}`);
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      change() {
        if (this.active == 1) {
          this.state = false;
          this.selectPage();
        } else if (this.active == 2) {
          this.state = true;
          this.selectPage();
        } else if (this.active == 3) {
          this.state = "";
          this.selectPage();
        }
      },
      selectAll() {
        selectAll().then((res) => {
          if (res.status) {
            this.columns = res.data;
          }
        });
      },
      selectPage() {
        selectPage(this.state).then((res) => {
          if (res.status) {
            this.all = res.data;
            this.all.forEach((item) => {
              this.columns.forEach((items) => {
                if (item.workOrderType == items.id) {
                  item.workOrderType = items.name;
                }
              });
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .padd {
    padding: 10px;
    font-size: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #009fff;
  }
  .padds {
    padding: 5px;
    font-size: 16px;
    box-sizing: border-box;
  }
</style>
